import { render, staticRenderFns } from "./StockDeclareCheck.vue?vue&type=template&id=16f3f7fa&scoped=true&"
import script from "./StockDeclareCheck.vue?vue&type=script&lang=js&"
export * from "./StockDeclareCheck.vue?vue&type=script&lang=js&"
import style0 from "./StockDeclareCheck.vue?vue&type=style&index=0&id=16f3f7fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3f7fa",
  null
  
)

export default component.exports